import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SubscriptionReportingApplicationsComponent } from './components/subscription-reporting-applications.component';
import { SubscriptionSiteTrafficComponent } from './components/subscription-site-traffic.component';

@NgModule({
    declarations: [SubscriptionReportingApplicationsComponent, SubscriptionSiteTrafficComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class SubscriptionReportingModule { }
